import { fetchLegends } from '@app/services/legendService'
import { getCurrentSubdomain } from '@app/utils/getCurrentSubdomain'
import { useQuery } from '@tanstack/react-query'

import type { LegendLookup } from '@app/types/layerTypes'

export function useFetchLegends() {
  const clientName = getCurrentSubdomain(
    window.location.hostname,
    import.meta.env.VITE_SAFE_DOMAIN ?? 'rex.local',
  )

  return useQuery<LegendLookup>({
    queryKey: ['legends', clientName],
    queryFn: () => fetchLegends(),
    enabled: Boolean(clientName),
    refetchOnMount: true,
  })
}
